import {Component, forwardRef, Input, OnInit} from '@angular/core';
import {ControlValueAccessor, NG_VALUE_ACCESSOR} from '@angular/forms';

@Component({
  selector: 'app-input-check-box',
  templateUrl: './input-check-box.component.html',
  styleUrls: ['./input-check-box.component.scss'],
  providers: [{
    provide: NG_VALUE_ACCESSOR,
    useExisting: forwardRef(() => InputCheckBoxComponent),
    multi: true
  }]
})
export class InputCheckBoxComponent implements OnInit, ControlValueAccessor{

  public inputModel: boolean;

  constructor() { }

  ngOnInit(): void {
  }

  private onChangeFn: any = () => {
  };
  private onTouchedFn: any = () => {
  };


  public registerOnChange(fn: any): void {
    this.onChangeFn = fn;
  }

  public registerOnTouched(fn: any): void {
    this.onTouchedFn = fn;
  }

  public writeValue(value: boolean): void {
    this.inputModel = value;
  }

  onCheckBoxClicked() {
    this.inputModel = !this.inputModel;
    this.onChangeFn(this.inputModel);
  }
}
